/* CartesianGrid.tsx generated by @compiled/babel-plugin v0.28.8 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const _12 = "._4t3i1osq{height:100%}";
const _11 = "._1bsb1osq{width:100%}";
const _10 = "._1lmcpu6d{grid-template-areas:\"axis-left plot\" \". axis-bottom\"}";
const _9 = "._zulp1nty{gap:0 0}";
const _8 = "._2z051qft{grid-template-rows:auto min-content}";
const _7 = "._yv0ey09t{grid-template-columns:min-content auto}";
const _6 = "._1e0c11p5{display:grid}";
const _5 = "._1ul9idpf{min-width:0}";
const _4 = "._1tkeidpf{min-height:0}";
const _3 = "._16jlkb7n{flex-grow:1}";
const _2 = "._kqswh2mm{position:relative}";
const _ = "._1e0c1txw{display:flex}";
export default function CartesianGrid(_ref) {
  let {
    children
  } = _ref;
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5]
    }), /*#__PURE__*/_jsx("div", {
      className: ax(["_1e0c1txw _kqswh2mm _16jlkb7n _1tkeidpf _1ul9idpf"]),
      children: /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_6, _7, _8, _9, _10, _5, _4, _11, _12]
        }), /*#__PURE__*/_jsx("div", {
          className: ax(["_1e0c11p5 _yv0ey09t _2z051qft _zulp1nty _1lmcpu6d _1ul9idpf _1tkeidpf _1bsb1osq _4t3i1osq"]),
          children: children
        })]
      })
    })]
  });
}